"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _motionMove = _interopRequireDefault(require("../animation/motion-move"));
var _base = require("@site/pattern-library-utils/base.functions");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var _useCarousel = require("./use-carousel");
var _carouselControl = _interopRequireDefault(require("../../page-body/sections/smart-testimonials-section/carousel-control"));
var _quickLearnCard = _interopRequireDefault(require("./quick-learn-card"));
var _quickLearnModal = _interopRequireDefault(require("./quick-learn-modal"));
var _actions = _interopRequireDefault(require("../../elements/other/actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SectionContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionContainer",
  class: "pl-sccldxq"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "HeadlineWrapper",
  class: "pl-h1tbgiz0"
});
const CarouselContainer = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "CarouselContainer",
  class: "pl-c1tzwu8k"
});
const Control = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "Control",
  class: "pl-coojt51"
});

/**
 * QuickLearnCardsSection Component.
 *
 * @param {Object} props React props
 * @param {string} props.id The id of the component
 * @param {string} props._name The name of the component
 * @param {string} props.sectionHeading The heading of the section
 * @param {Array} props.cards The cards to display
 * @param {boolean} props.partial Whether the section is a partial
 * @param {string} props.verticalMargin The vertical margin of the section
 * @returns {React.ReactElement} QuickLearnCardsSection Component
 * @public
 */
function QuickLearnCardsSection({
  id,
  _name,
  sectionHeading,
  sectionCta,
  cards,
  partial,
  verticalMargin
}) {
  const {
    carouselRef,
    cardRef,
    next,
    prev
  } = (0, _useCarousel.useCarousel)();
  const [activeModal, setActiveModal] = (0, _react.useState)(true);
  const handleOpenModal = cardIndex => {
    setActiveModal(cardIndex);
  };
  const handleCloseModal = () => {
    setActiveModal(null);
  };
  const indexesOfCardsWithModals = (0, _react.useMemo)(() => cards.map((card, index) => card?.modalCards && index).filter(val => val != null), [cards]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SectionContainer, {
    id: `id-${id}`,
    _name: _name,
    partial: partial,
    padding: "none",
    verticalMargin: verticalMargin,
    dataCy: "quick-learn-cards-section"
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    mode: "fluid",
    intensity: "300",
    variant: "moveUpFixed",
    triggerOnce: true
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_text.default.h2, {
    as: "heading",
    size: 5,
    className: "section-heading",
    text: sectionHeading
  })), sectionCta && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "ctas"
  }, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: [sectionCta]
  }))), /*#__PURE__*/_react.default.createElement(CarouselContainer, {
    ref: carouselRef,
    mode: "fluid",
    intensity: "400",
    variant: "moveUpFixed",
    staggerChildren: true,
    intensityMultiplier: 2,
    triggerOnce: true
  }, cards?.length > 0 && cards.map((item, index) => {
    const {
      _name: cardName,
      cardEyebrow,
      cardHeading,
      cardImage,
      modalCards,
      cardCta,
      cardInvert,
      cardHeadlineTag,
      cardEyebrowTag
    } = item;
    const handlePlay = () => handleOpenModal(index);
    const idValue = `${id}-${index}`;
    const nameValue = cardName ? cardName : `${_name}-card-${index}`;
    const refValue = index === 0 ? cardRef : null;
    const ctaValue = modalCards || cardCta;
    return /*#__PURE__*/_react.default.createElement(_quickLearnCard.default, {
      id: idValue,
      _name: nameValue,
      key: index,
      className: `card-${index}`,
      eyebrow: cardEyebrow,
      eyebrowTag: cardEyebrowTag,
      heading: cardHeading,
      headlineTag: cardHeadlineTag,
      image: cardImage,
      ref: refValue,
      handleClick: handlePlay,
      cta: ctaValue,
      invert: cardInvert
    });
  })), /*#__PURE__*/_react.default.createElement(Control, {
    mode: "fluid",
    intensity: "200",
    variant: "moveUpFixed",
    triggerOnce: true,
    delay: 0.5,
    className: "carousel-buttons"
  }, cards?.length > 1 && /*#__PURE__*/_react.default.createElement(_carouselControl.default, {
    handleNextButtonClick: next,
    handlePrevButtonClick: prev,
    prevButtonAriaLabel: "previous",
    nextButtonAriaLabel: "next"
  }))), indexesOfCardsWithModals.map((cardIndex, ix) => {
    const card = cards[cardIndex];
    return /*#__PURE__*/_react.default.createElement(_quickLearnModal.default, {
      key: ix,
      id: `quick-learn-${ix}`,
      _name: `quick-learn-${ix}`,
      show: cardIndex === activeModal,
      onClose: handleCloseModal,
      selectedCards: card.modalCards,
      layoutClasses: card.layoutClasses,
      eyebrow: card.eyebrow,
      heading: card.heading,
      description: card.description,
      ctas: card.ctas,
      bottomCta: card.bottomCta
    });
  }));
}
var _default = exports.default = QuickLearnCardsSection;
QuickLearnCardsSection.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  sectionHeading: _propTypes.default.string,
  cards: _propTypes.default.array,
  ..._boxModelSize.marginProps
};